import '../styles/slider.less';
import $ from 'jquery';
import * as common from '../../../shared/modules/common';
import { render } from 'mustache';
import view from './sliderView';

/**
 * Returns the CSS property value of a jQuery object by one or more property names.
 *
 * @param A CSS property name or array of property names.
 *
 * @return The value of the property name or the first value found going along the property names array.
 */
function getCssValue($item, cssPropName) {
    var value,
        i;
    if (cssPropName instanceof Array) {
        for (i = 0; !value && i < cssPropName.length; i++) {
            value = parseInt($item.css(cssPropName[i]), 10);
        }
    } else {
        value = parseInt($item.css(cssPropName), 10);
    }
    return value;
}

/**
 * A class which represents a Slider widget. This defines the structure and the main behavior of the widget.
 *
 * @param The jQuery element which is the slider markup.
 */
function Slider($slider) {
    var model = {
            min: new common.ObservableValue(0),
            max: new common.ObservableValue(100),
            basePoint: new common.ObservableValue(0),
            width: getCssValue($slider, 'width'),
            hasFloatingBase: function () {
                return model.min.value() < model.basePoint.value() && model.basePoint.value() < model.max.value();
            }
        },
        components = {
            containers: undefined,
            sliderBase: {},
            scale: undefined,
            inputs: [],
            indicators: [],
            thumbs: [],
            markers: [],
            addComponent: function (component) {
                if (component instanceof Indicator) {
                    this.indicators.push(component);
                } else
                if (component instanceof Thumb) {
                    this.thumbs.push(component);
                } else
                if (component instanceof Marker) {
                    this.markers.push(component);
                } else
                if (component instanceof common.ObservableValue) {
                    this.inputs.push(component);
                }
            }
        },
        positionCalculator,

        valueSelector = $slider.data('value-selector'),
        $valueElems = valueSelector !== undefined ? $(valueSelector) : $('input', $slider),
        indicatorColor = $slider.data('indicator-color') !== undefined
                ? $slider.data('indicator-color')
                : undefined,
        scaleFormatterReference = $slider.data('label-formatter'),
        scaleFormatterFunction = scaleFormatterReference !== undefined
                ? common.resolveReference(scaleFormatterReference)
                : function (a) { return a; },
        scaleStepSize = common.intData($slider, 'scale-step-size', undefined),
        showBoundaries = !(scaleStepSize && scaleStepSize > 0),
        stepSize = common.intData($slider, 'step-size', model.stepSize);

    function cleanupView() {
        $slider.find('> div').remove();
    }

    function buildContainers(model, showBoundaries) {
        var conf = {
                showBoundaries: showBoundaries,
                sliderWidth: model.width,
                minValue: model.min.value(),
                maxValue: model.max.value()
            },
            $containers = $(render(view.container, conf));

        $slider.append($containers);
        return {
            $sliderContainer: $('.uwr-slider-container', $slider),
            $indicatorContainer: $('.uwr-slider-indicator-container', $slider)
        };
    }

    function buildSliderBase(model, calculator) {
        var sliderBase = new Indicator({
                parent: components.containers.$indicatorContainer,
                start: model.min.value(),
                end: model.max.value(),
                basePoint: model.basePoint.value(),
                calculator: calculator,
                withFloatingBase: model.hasFloatingBase(),
                isSliderBase: true
            });
        return sliderBase;
    }

    function buildScale(model, scaleStepSize, scaleFormatterFunction, positionCalculator) {
        return new Scale({
            min: model.min.value(),
            max: model.max.value(),
            basePoint: model.basePoint.value(),
            stepSize: scaleStepSize,
            width: model.width,
            scaleFormatter: scaleFormatterFunction,
            calculator: positionCalculator
        });
    }

    function buildObservableValueForInput($value, positionCalculator) {
        var ov = new common.ObservableValue($value.val(), function (newValue) {
            $value.val(newValue);
            $value.trigger('change');
        });

        $value.data('valueObject', ov);
        $value.on('change', function () {
            ov.value(positionCalculator.closestStepValue($value.val()));
        });
        return ov;
    }

    function buildIndicator(model, value, indicatorColor, positionCalculator) {
        var indicator = new Indicator({
                parent: components.containers.$indicatorContainer,
                start: model.basePoint.value(),
                end: value,
                basePoint: model.basePoint.value(),
                calculator: positionCalculator,
                withFloatingBase: model.hasFloatingBase(),
                isSliderBase: false
            });
        indicator.getElement().css('background-color', indicatorColor);
        return indicator;
    }

    function buildThumb(value, positionCalculator) {
        var thumb = new Thumb({
                parent: components.containers.$indicatorContainer,
                value: value,
                calculator: positionCalculator
            });
        return thumb;
    }

    function buildMarker(value, positionCalculator) {
        var marker = new Marker({
                parent: components.containers.$indicatorContainer,
                value: value,
                calculator: positionCalculator
            });
        return marker;
    }

    function appendScale() {
        if (scaleStepSize) {
            components.scale = buildScale(model, scaleStepSize, scaleFormatterFunction, positionCalculator);
            components.containers.$indicatorContainer.append(components.scale.getElement());

            model.max.on('change:value', function (newValue) { components.scale.max.value(newValue); });
            model.min.on('change:value', function (newValue) { components.scale.min.value(newValue); });
            model.basePoint.on('change:value', function (newValue) { components.scale.basePoint.value(newValue); });
        }
    }

    function bindItemsWithEvents(observableValueElem, indicator, indicatorBindableElem, thumb, marker) {
        observableValueElem.on('change:value', function (newValue) {
            indicatorBindableElem.value(newValue);
            marker.value.value(newValue);
            thumb.value.value(newValue);
        });
        indicatorBindableElem.on('change:value', function (newValue) { observableValueElem.value(newValue); });

        thumb.value.on('change:value', function (newValue) { observableValueElem.value(newValue); });
        thumb.on('thumb:mousestatechange', function (mouseState) {
            marker.setVisible(mouseState.active || mouseState.hover);
        });
    }

    function getNearestThumb(value) {
        var i,
            nearestThumbItem,
            currentDistance,
            baseDistance = (model.max.value() - model.min.value());

        for (i = 0; i < components.thumbs.length; i++) {
            currentDistance = Math.abs(components.thumbs[i].value.value() - value);
            if (!nearestThumbItem || currentDistance < baseDistance) {
                baseDistance = currentDistance;
                nearestThumbItem = components.thumbs[i];
            }
        }

        return nearestThumbItem;
    }

    function setThumbFromValue(newValue) {
        var nearestThumbItem = components.thumbs[0];

        if (components.thumbs.length > 1) {
            nearestThumbItem = getNearestThumb(newValue);
        }

        nearestThumbItem.value.value(newValue);
        nearestThumbItem.setHover(true);
    }

    function bindSliderBaseClick() {
        components.sliderBase.on('indicator:click', function (newValue) {
            setThumbFromValue(newValue);
        });
    }

    function handleTouchEvent(jqueryEvent) {
        var i,
            touch,
            touchEvent = jqueryEvent.originalEvent,
            offsetX = components.containers.$indicatorContainer.get(0).getBoundingClientRect().left;

        for (i = 0; i < touchEvent.targetTouches.length; i++) {
            touch = touchEvent.targetTouches[i];
            setThumbFromValue(positionCalculator.positionToValue(touch.clientX - offsetX));
        }
    }

    function indicatorTouchStartMove(touchEvent) {
        touchEvent.preventDefault();
        handleTouchEvent(touchEvent);
    }

    function indicatorTouchEndCancel(touchEvent) {
        var i;

        if (touchEvent.cancelable) {
            touchEvent.preventDefault();
        }

        for (i = 0; i < components.thumbs.length; i++) {
            components.thumbs[i].setHover(false);
        }
    }

    function setTouchHandlers() {
        var $indicatorContainer = components.containers.$indicatorContainer;

        $slider.css({'touch-action': 'none', 'user-select': 'none'});

        $indicatorContainer.on('touchstart touchmove', indicatorTouchStartMove);
        $indicatorContainer.on('touchend touchcancel', indicatorTouchEndCancel);
    }

    function init() {
        var sliderType = common.data($slider, 'type', 'simple'),
            rangeIndicator;

        model.max.value(common.intData($slider, 'max-value', model.max.value()));
        model.min.value(common.intData($slider, 'min-value', model.min.value()));
        model.basePoint.value(common.intData($slider, 'base-value', model.min.value()));
        model.width = common.intData($slider, 'width', model.width);
        $slider.css('width', 'auto');

        positionCalculator = new Calculator({
            min: model.min.value(),
            max: model.max.value(),
            basePoint: model.basePoint.value(),
            width: model.width,
            stepSize: stepSize,
            inputs: components.inputs
        });

        components.containers = buildContainers(model, showBoundaries);
        components.sliderBase = buildSliderBase(model, positionCalculator);

        $valueElems.each(function () {
            var $value = $(this),
                observableValueElem = buildObservableValueForInput($value, positionCalculator),
                ownIndicatorColor = $value.data('slider-indicator-color') !== undefined
                    ? $value.data('slider-indicator-color')
                    : indicatorColor,
                thumb,
                marker,
                indicator,
                indicatorBindableItem;

            thumb = buildThumb($value.val(), positionCalculator);
            marker = buildMarker($value.val(), positionCalculator);
            if (sliderType === 'range') {
                if (!rangeIndicator) {
                    rangeIndicator = buildIndicator(model, $value.val(), ownIndicatorColor, positionCalculator);
                    indicatorBindableItem = rangeIndicator.start;
                    indicator = rangeIndicator;
                    rangeIndicator.setStart(thumb.value.value());
                    components.addComponent(rangeIndicator);
                } else {
                    rangeIndicator.setEnd(thumb.value.value());
                    indicatorBindableItem = rangeIndicator.end;
                    indicator = undefined;
                }
            } else {
                indicator = buildIndicator(model, $value.val(), ownIndicatorColor, positionCalculator);
                indicatorBindableItem = indicator.end;
                components.addComponent(indicator);
            }
            bindItemsWithEvents(observableValueElem, indicator, indicatorBindableItem, thumb, marker);
            components.addComponent(observableValueElem);
            components.addComponent(thumb);
            components.addComponent(marker);
            setTouchHandlers();
        });

        appendScale();
        bindSliderBaseClick();
    }

    cleanupView();
    init();
}

/**
 * The scale which shows some available values (defined by some settings as the stepSize or the scaleFormatter) of
 * an interval in an easy format.
 *
 * @param conf A JSON object, which contains the following parameters:
 *         min: the minimum point of the interval,
 *         max: the maximum point of the interval,
 *         basePoint: the basePoint point of the interval,
 *         stepSize: the size of the scale stepping (e.g. every fifth value should be displayed),
 *         width: the displayed width of the interval,
 *         scaleFormatter: a formatter function to format the scale label contents (e.g. with percent sign),
 *         calculator: a Calculator object
 */

function Scale(conf) {
    var $scale = $(render(view.scale)),
        scaleLabels,
        i,
        $label,
        labelPosition,
        labelPositionCorrection,
        labelWidth;

    function scaleLabelArray(stepSize, minValue, maxValue, basePointValue) {
        var label,
            labels = [];
        if (stepSize && stepSize > 0) {
            // Find the first (min) scale value
            label = basePointValue;
            while (label >= minValue) {
                label -= stepSize;
            }
            label += stepSize;
            while (label <= maxValue) {
                labels.push(label);
                label += stepSize;
            }
        }
        return labels;
    }

    this.getElement = function () {
        return $scale;
    };

    scaleLabels = scaleLabelArray(conf.stepSize, conf.min, conf.max, conf.basePoint);
    labelWidth = Math.floor(conf.width / scaleLabels.length);

    for (i = 0; i < scaleLabels.length; i++) {
        labelPositionCorrection = Math.round(labelWidth / 2) + i * labelWidth;
        labelPosition = conf.calculator.valueToPosition(scaleLabels[i]) - labelPositionCorrection;
        $label = $(render(view.label, {}));
        $label.css('width', labelWidth);
        $label.css('left', labelPosition);
        $label.text(conf.scaleFormatter(scaleLabels[i]));
        $scale.append($label);
    }
}

/**
 * The colored indicator line between two values.
 *
 * @param conf A JSON object, which contains the following parameters:
 *              parent: the parent jQuery object which this will be appended
 *              start: the start point of the indicator (the lowest value),
 *              end: the end point of the indicator (the highest value),
 *              basePoint: the basePoint point of the displayed interval,
 *              calculator: a Calculator object,
 *              withFloatingBase: the basePoint point is in the interval and not boundary value,
 *              isSliderBase: indicator is sliderBase
 */
function Indicator(conf) {
    var $indicator,
        self = this;

    function updateView() {
        var minValue = Math.min(self.start.value(), self.end.value()),
            indicatorLeft = conf.calculator.valueToPosition(minValue) - self.geometry.radius,
            endPos = conf.calculator.valueToPosition(self.end.value()),
            startPos = conf.calculator.valueToPosition(self.start.value()),
            indicatorWidth = Math.abs(endPos - startPos) + self.geometry.radius * 2;

        if (conf.withFloatingBase && !conf.isSliderBase) {
            // If the basePointValue less or equals to inputValue, then the indicator direction is left-to-right.
            indicatorLeft += conf.basePoint <= self.end.value() ? self.geometry.radius : 0;
            indicatorWidth -= self.geometry.radius;
        }
        $indicator.css('left', indicatorLeft + 'px');
        $indicator.css('width', indicatorWidth + 'px');
    }

    this.start = new common.ObservableValue(conf.start, updateView);
    this.setStart = function (startValue) {
        this.start.value(startValue);
    };

    this.end = new common.ObservableValue(conf.end, updateView);
    this.setEnd = function (endValue) {
        this.end.value(endValue);
    };

    this.getElement = function () {
        return $indicator;
    };

    common.Observable.call(this);

    $indicator = $(render(view.indicator, {}));
    $indicator.on('click', function (e) {
        var parentOffset = $(this).parent().offset(),
            clickPos = e.pageX - parentOffset.left,
            clickedValue = conf.calculator.positionToValue(clickPos);

        clickedValue = conf.calculator.closestStepValue(clickedValue);
        if (!conf.isSliderBase) {
            self.end.value(clickedValue);
            updateView();
        }
        self.trigger('indicator:click', clickedValue);
    });

    if (!conf.isSliderBase && conf.withFloatingBase) {
        $indicator.addClass('uwr-slider-indicator-angled');
    }
    if (conf.isSliderBase) {
        $indicator.addClass('uwr-slider-bar');
    }

    conf.parent.append($indicator);
    this.geometry = {
        radius: getCssValue($indicator, ['border-radius', 'border-top-left-radius'])
                || getCssValue($indicator, 'height') / 2
    };
    updateView();
}

/**
 * The thumb which represents a value from the interval.
 *
 * @param conf A JSON object, which contains the following parameters:
 *              parent: the parent jQuery object which this will be appended
 *              value: The initial value which is associated to this thumb,
 *              calculator: a Calculator object
 */
function Thumb(conf) {
    var $thumb,
        mouseState = {
            active: false,
            hover: false
        },
        self = this;

    function switchClass(className, add) {
        if (add) {
            $thumb.addClass(className);
        } else {
            $thumb.removeClass(className);
        }
    }
    function updateView() {
        var thumbLeft = conf.calculator.valueToPosition(self.value.value()) - self.geometry.radius;
        $thumb.css('left', thumbLeft + 'px');
        if (mouseState.active) {
            switchClass('uwr-slider-thumb-active', true);
        } else {
            switchClass('uwr-slider-thumb-active', false);
            if (mouseState.hover) {
                switchClass('uwr-slider-thumb-hover', true);
            } else {
                switchClass('uwr-slider-thumb-hover', false);
            }
        }
    }

    this.value = new common.ObservableValue(conf.value, updateView);

    this.getElement = function () {
        return $thumb;
    };

    this.setActive = function (active) {
        mouseState.active = active;
        this.trigger('thumb:mousestatechange', mouseState);
    };

    this.setHover = function (hover) {
        mouseState.hover = hover;
        this.trigger('thumb:mousestatechange', mouseState);
    };

    common.Observable.call(this);

    $thumb = $(render(view.thumb, {}));
    $thumb.on('mousedown', function (e) {
        e.preventDefault();
        self.trigger('thumb:dragstart', null);
        self.setActive(true);
        $thumb.css('cursor', 'pointer');
        var parsedThumbPos = parseInt($thumb.css('left').replace('px', ''), 10),
            startThumbPos = parsedThumbPos + self.geometry.radius,
            startMouseX = e.clientX,
            eventNamespace = '.uwr-slider-' + new Date().getTime(), // Date.now() from IE9+
            boundaryValues = conf.calculator.boundaryValues(self.value.value());

        $(document).on('mousemove' + eventNamespace, function (e) {
            var mouseOffsetX = (e.clientX - startMouseX),
                thumbPos = startThumbPos + mouseOffsetX,
                thumbValue;
            thumbValue = conf.calculator.positionToValue(thumbPos);
            thumbValue = conf.calculator.closestStepValue(thumbValue);
            thumbValue = Math.max(Math.min(thumbValue, boundaryValues.maxValue), boundaryValues.minValue);
            self.value.value(thumbValue);
            e.preventDefault();
            e.stopPropagation();
        });

        $(document).on('mouseup' + eventNamespace, function () {
            self.trigger('thumb:dragend');
            self.setActive(false);
            $(document).off('mousemove' + eventNamespace);
            $(document).off('mouseup' + eventNamespace);
            $thumb.css('cursor', 'auto');
        });
    });

    $thumb.on('mouseover', function () {
        self.trigger('thumb:mouseover');
        self.setHover(true);
    });

    $thumb.on('mouseout', function () {
        self.trigger('thumb:mouseout');
        self.setHover(false);
    });

    this.on('thumb:mousestatechange', updateView);

    conf.parent.append($thumb);
    self.geometry = {
        radius: getCssValue($thumb, ['border-radius', 'border-top-left-radius'])
                || getCssValue($thumb, 'height') / 2
    };
    updateView();
}

/**
 * The marker value above the thumb.
 *
 * @param conf A JSON object, which contains the following parameters:
 *         value: The initial value which is associated to this marker,
 *         calculator: a Calculator object
 */
function Marker(conf) {
    var $marker = $(render(view.marker)),
        self = this,
        isVisible = false,
        markerLeft;

    function updateView() {
        if (isVisible) {
            $marker.text(self.value.value());
            markerLeft = conf.calculator.valueToPosition(self.value.value()) - Math.floor(self.geometry.width / 2);
            $marker.css('left', markerLeft + 'px');
            $marker.css('visibility', 'visible');
        } else {
            $marker.css('visibility', 'hidden');
        }
    }

    this.value = new common.ObservableValue(conf.value, updateView);

    this.getElement = function () {
        return $marker;
    };

    this.setVisible = function (visible) {
        isVisible = visible;
        updateView();
    };

    conf.parent.append($marker);
    self.geometry = {
        width: getCssValue($marker, 'width')
    };
    updateView();
}

/**
 * The calculator works on a range of values. All values out of this range will be changed
 * to the nearest boundary value.
 *
 * @param conf A JSON object, which contains the following parameters:
 *         min: the minimum point of the interval,
 *         max: the maximum point of the interval,
 *         basePoint: the basePoint point of the interval,
 *         width: the displayed width of the interval,
 *         stepSize: the size of the value stepping (e.g. every fifth value can be selected),
 *         inputs: the array of the input values
 */
export function Calculator(conf) {
    /**
     * @param {number} The position (px) which should be transformed to value. The zero
     *                 position is at the left endpoint of the scale.
     * @return The value associated to the position.
     */
    this.positionToValue = function (position) {
        var range = conf.max - conf.min,
            relativeValue = Math.round(position * range / conf.width),
            value = relativeValue + conf.min,
            limitedValue = Math.max(Math.min(value, conf.max), conf.min);

        return limitedValue;
    };

    /**
     * @param {number} The value which should be transformed to position (px).
     * @return The relative position (px) associated to the value. The zero
     *         position is at the left endpoint of the scale.
     */
    this.valueToPosition = function (value) {
        var limitedValue = Math.max(Math.min(value, conf.max), conf.min),
            relativeValue = limitedValue - conf.min,
            range = conf.max - conf.min,
            position = Math.round(relativeValue * conf.width / range);

        return position;
    };

    /**
     * @param {number} The value which we try to find closest valid step value for.
     * @return The closest valid step value to the value.
     */
    this.closestStepValue = function (value) {
        var closestValue = value,
            moduloValue;

        if (conf.stepSize) {
            moduloValue = (value - conf.basePoint) % conf.stepSize;
            closestValue = Math.abs(moduloValue) < conf.stepSize / 2
                    ? value - moduloValue
                    : value - moduloValue + common.sign(moduloValue) * conf.stepSize;
            if (closestValue > conf.max) {
                closestValue = closestValue - conf.stepSize;
            }
            if (closestValue < conf.min) {
                closestValue = closestValue + conf.stepSize;
            }
        }

        return closestValue;
    };

    /**
     * @return The boundary values for a value.
     * Notice: This is enough for one thumb, but more thumbs require a more sophisticated solution.
     */
    this.boundaryValues = function (value) {
        var maxV = conf.max,
            minV = conf.min,
            maxInputDiff,
            minInputDiff,
            maxValueDiff,
            minValueDiff,
            inputValue,
            lastInputValue,
            prevInputValueIsSame,
            i;

        for (i = 0; i < conf.inputs.length; i++) {
            inputValue = conf.inputs[i].value();
            prevInputValueIsSame = inputValue === lastInputValue;
            maxInputDiff = inputValue - value;
            minInputDiff = value - inputValue;
            maxValueDiff = maxV - value;
            minValueDiff = value - minV;
            if (0 < maxInputDiff && maxInputDiff < maxValueDiff) {
                maxV = inputValue;
            }
            if (prevInputValueIsSame || (0 < minInputDiff && minInputDiff < minValueDiff)) {
                minV = inputValue;
            }
            lastInputValue = inputValue;
        }

        return {
            maxValue: maxV,
            minValue: minV
        };
    };
}

/**
 * @param {function} Optional. The function to run after initialization.
 */
export function init(callback) {
    $('.uwr-slider').each(function () {
        /* eslint-disable no-new */
        new Slider($(this));
        /* eslint-enable no-new */
    });
    common.invoke(callback);
}



//////////////////
// WEBPACK FOOTER
// ./widgets/Slider/js/slider.js
// module id = 41
// module chunks = main